import { Sparkles, MousePointerClick, Heart, ExternalLink } from 'lucide-react';
import { FloatingShapes } from './FloatingShapes';

export function Hero() {
  return (
    <section className="pt-24 pb-12 px-6 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 dark:from-indigo-950/30 dark:via-purple-950/30 dark:to-pink-950/30 opacity-50"></div>
      
      <FloatingShapes />

      <div className="max-w-7xl mx-auto text-center relative z-10">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm mb-6 border border-gray-200/50 dark:border-gray-700/50">
          <Sparkles className="w-4 h-4 text-yellow-500 dark:text-yellow-400" />
          <span className="text-sm font-medium text-gray-800 dark:text-gray-200">Master multiplication tables with fun!</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 dark:from-indigo-400 dark:via-purple-400 dark:to-pink-400 bg-clip-text text-transparent font-display animate-fade-in opacity-0" style={{ animation: 'fadeIn 0.8s ease-out 0.2s forwards' }}>
          Master Multiplication Tables
        </h1>
        
        <p className="text-xl md:text-2xl mb-8 text-gray-700 dark:text-gray-300 max-w-3xl mx-auto animate-fade-in opacity-0" style={{ animation: 'fadeIn 0.8s ease-out 0.4s forwards' }}>
          Make learning multiplication tables fun and interactive! 🎉
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <div className="animate-bounce flex items-center justify-center gap-2 text-gray-700 dark:text-gray-300">
            <MousePointerClick className="w-5 h-5" />
            <span>Scroll down to start playing!</span>
          </div>

          <a
            href="https://superprofile.bio/vp/64188fab190024001f59f638"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 dark:from-purple-500 dark:to-pink-500 rounded-full text-lg font-semibold text-white transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center gap-2 overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-pink-400 dark:from-purple-300 dark:to-pink-300 animate-pulse opacity-75"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 dark:from-purple-500 dark:to-pink-500"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 dark:from-purple-500 dark:to-pink-500 animate-glow"></div>
            <div className="relative z-10 flex items-center gap-2">
              <Heart className="w-5 h-5 animate-beat" fill="currentColor" />
              <span>Support Us</span>
              <ExternalLink className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}